import * as z from 'zod';
import * as ba from './base';
import { SCRIPT_SCHEMA } from '../scripting';
import { isComponentContext, assertVueComponent } from '../helpers';

export interface LogoutActionArgs {}

export class LogoutAction extends ba.Action<LogoutActionArgs, any> {
  static get manifest() {
    return {
      name: 'logout',
      schema: z.object({})
    };
  }

  async handle(event: ba.ActionEvent, args: LogoutActionArgs) {
    assertVueComponent(event.component);
    return event.component.$app.auth.logout();
  }
}
